import React, { useCallback, useState } from 'react';

interface IProps<T> {
  data: T[];
  onChangeOrder: (data: T[]) => void;
}

export const useDragNDrop = <T>({ data, onChangeOrder }: IProps<T>) => {
  const [dragItem, setDragItem] = useState<T | null>(null);

  const handleDrop = useCallback(
    (target: T) => {
      if (dragItem && target) {
        const targetIndex = data.indexOf(target);
        const dragItemIndex = data.indexOf(dragItem);

        const itemsCopy = [...data];
        itemsCopy[targetIndex] = dragItem;
        itemsCopy[dragItemIndex] = target;

        onChangeOrder(itemsCopy);
      }
    },
    [data, dragItem, onChangeOrder]
  );
  const handleOver = useCallback((event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  }, []);
  const handleStart = useCallback((item: T, e: React.DragEvent) => {
    e.stopPropagation();
    setDragItem(item);
    e.dataTransfer.setData('text/plain', '');
  }, []);
  const handleLeave = useCallback(() => {
    setTimeout(() => {
      setDragItem(null);
    }, 1000);
  }, []);

  return {
    handleDrop,
    handleOver,
    handleStart,
    handleLeave
  };
};
